module.exports = __webpack_public_path__ + "img/img7.fb3af000.jpg";